<script setup>
import Commons from '@/shared/utils/commons'
import TableList from '../others/TableList.vue'
import ModalComponent from '@/presentation/components/dialog/ModalComponent.vue'
import { ref } from 'vue'

const cols = [
  {
    name: 'Nom',
    id: 'name',
    value(el) {
      if (typeof el == 'number') return ['john doe']
      return [el.name]
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = el
      modal.value.show()
    },
    value() {},
  },
]

const detailData = ref(null)
const modal = ref(null)
</script>

<template>
  <div class="p-5">
    <TableList
      title="Zones de livraison"
      dataKey="deliveryLocations"
      hasSearch
      :cols="cols"
    ></TableList>

    <ModalComponent ref="modal">
      <div class="w-screen max-w-[80vw] md:max-w-screen-sm p-5">
        <div v-html="Commons.jsonToHtml(detailData)"></div>
      </div>
    </ModalComponent>
  </div>
</template>
